<mat-dialog-content [ngClass.xs]="'w-mobile'" [ngClass.gt-xs]="'w-desktop'">
    <div class="thx-text">
        Thank you for posting with us. We appreciate your business.
    </div>
    <div class="thx-term">*We may remove your ad if it violates our&nbsp;<a href="terms-of-use">Terms And Conditions</a></div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button [color]="'thx-exit'" mat-dialog-close>OK</button>
</mat-dialog-actions>
